const form = document.getElementById('ean-print-form');

if (form) {
    const fields = document.getElementById('ean-print-fields');
    const ean = document.getElementById('label-ean');
    const quantity = document.getElementById('label-quantity');
    const status = document.getElementById('ean-print-status');
    let printing = false;

    form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (printing || !form.reportValidity()) return;

        printing = true;
        fields.disabled = true;
        status.className = 'mt-4 text-sm text-gray-700';
        status.textContent = 'Preisschilder werden gedruckt…';

        try {
            const response = await fetch(form.action, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': form.querySelector('[name="_token"]').value,
                },
                body: JSON.stringify({ean: ean.value.trim(), quantity: Number(quantity.value)}),
            });
            const data = await response.json().catch(() => ({}));
            if (!response.ok || data.ok !== true) {
                const validationError = Object.values(data.errors || {}).flat()[0];
                throw new Error(data.error || validationError || 'Druckstatus unbekannt. Bitte Sitzung und Drucker prüfen, bevor erneut gedruckt wird.');
            }

            const price = new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(data.price);
            status.className = 'mt-4 text-sm text-green-700';
            status.textContent = `${data.printed_quantity} Preisschild(er) gedruckt: ${data.ean} – ${data.name} – ${price}`;
            ean.value = '';
        } catch (error) {
            status.className = 'mt-4 text-sm text-red-700';
            status.textContent = error instanceof TypeError
                ? 'Verbindung unterbrochen. Druckstatus unbekannt. Bitte Drucker prüfen, bevor erneut gedruckt wird.'
                : error.message;
        } finally {
            printing = false;
            fields.disabled = false;
            ean.focus();
            ean.select();
        }
    });
}
